<template>
  <v-row>
    <v-col cols="12" md="12" class="mt-0 pt-0">
      <v-row>
        <v-col cols="12" md="8" class="d-flex align-center">
          <h1>Paradas em aberto</h1>
        </v-col>
        <v-col cols="12" md="4" class="d-flex align-end mt-1">
          <v-text-field class="mx-4" label="Número da Nota Fiscal" v-model="nfeNumber"></v-text-field>
          <v-btn @click="searchNfeNumber" color="success" large>Buscar</v-btn>
        </v-col>
      </v-row>

      <div v-show="nodes.length > 0" class="mt-6">
        <v-progress-linear indeterminate v-show="loadingStops"></v-progress-linear>
        <table-title-row :columnsOptions="columnsStopOptions"></table-title-row>
        <template v-for="(node, nodeIndex) in nodes">
          <div :key="nodeIndex">
            <table-body-row
              :node="node"
              :nodeIndex="nodeIndex"
              :columns="columnsStops"
              :lengthDataToTruncate="20"
              :type="'Parada'"
              :enableCheckbox="true"
              :selectedCheckbox="selectedCheckbox"
              @onExpand="onExpand(node)"
              @changeCheckbox="changeSelectedCheckbox"
            >
            </table-body-row>
            <Status :nodeIndex="nodeIndex" :status="node.data.nfeStatus" />

            <v-row v-if="node.open" class="mb-2" style="margin-top: 0">
              <v-col cols="12" class="px-4">
                <v-card>
                  <v-card-text>
                    <table-title-row :columnsOptions="columnsDeliveriesOptions"></table-title-row>
                    <template v-for="(delivery, deliveryIndex) in node.children">
                      <div :key="deliveryIndex">
                        <table-body-row
                          :node="delivery"
                          :nodeIndex="deliveryIndex"
                          :stopIndex="nodeIndex"
                          :columns="columnsDeliveries"
                          :lengthDataToTruncate="16"
                          :type="'Entrega'"
                          :enableCheckbox="true"
                          :selectedCheckbox="selectedCheckbox"
                          @onExpand="onExpand(delivery)"
                          @changeCheckbox="changeSelectedCheckbox"
                        >
                        </table-body-row>
                        <Status :nodeIndex="deliveryIndex" :status="delivery.data.nfeStatus" />

                        <v-row v-if="delivery.open" style="margin-top: 0">
                          <v-col cols="12">
                            <v-card>
                              <v-card-text class="mb-4">
                                <table-title-row :columnsOptions="columnsNfeOptions"></table-title-row>

                                <template v-for="(nfe, nfeIndex) in delivery.children">
                                  <div :key="nfeIndex">
                                    <table-body-row
                                      :node="nfe"
                                      :nodeIndex="nfeIndex"
                                      :columns="columnsNfe"
                                      :lengthDataToTruncate="16"
                                      :type="'Nota Fiscal'"
                                      :selectedCheckbox="selectedCheckbox"
                                    >
                                    </table-body-row>
                                    <Status :nodeIndex="nfeIndex" :status="nfe.data.nfeStatus" />
                                  </div>
                                </template>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </div>
                    </template>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </template>

        <div class="d-flex align-center justify-space-between mt-8">
          <v-pagination v-model="page" :length="paginateTransfer.totalPages" :total-visible="7"></v-pagination>
          <v-btn :disabled="shouldDisableButton" large color="success" @click="transferStops()" class="ml-4">
            Transferir
          </v-btn>
        </div>
      </div>
      <v-row class="d-flex justify-center mt-6 mb-2" v-if="stopsTranshipmentId && nodes.length === 0">
        Nenhuma parada encontrada
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { TranshipmentTransferHandler } from '@/store/modules/transhipmentTransfer';
import { mapActions, mapMutations, mapState } from 'vuex';
import maskCPF from '@/utils/maskCPF';
import maskCNPJ from '@/utils/maskCNPJ';
import maskPrice from '@/utils/maskPrice';
import maskData from '@/utils/maskData';
import TableTitleRow from '@/components/Table/Table-Title-Row.vue';
import TableBodyRow from '@/components/Table/Table-Body-Row.vue';
import Status from '@/components/Table/Status.vue';
import changeCheckbox from '@/utils/changeSelectedCheckbox';
export default {
  components: {
    TableTitleRow,
    TableBodyRow,
    Status
  },

  data: () => ({
    nfeNumber: '',
    filtersLoading: false,
    nodes: [],
    loadingStops: false,
    columnsStopOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'cityName',
        text: 'Cidade'
      },
      {
        value: 'recipientCpfOrCnpj',
        text: 'CPF/CNPJ do Destinatário'
      },
      {
        value: 'recipientName',
        text: 'Nome do Destinatário'
      },
      {
        value: 'transhipmentPrice',
        text: 'Preço do Transbordo'
      },
      { value: 'actions', text: 'Ações' }
    ],
    columnsStops: ['type', 'cityName', 'recipientCpfOrCnpj', 'recipientName', 'transhipmentPrice', 'actions'],
    columnsDeliveriesOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      {
        value: 'numberCte',
        text: 'Número CTE'
      },
      {
        value: 'authorizationDate',
        text: 'Data de Autorização'
      },
      {
        value: 'costFreight',
        text: 'Custo do Frete'
      },
      {
        value: 'deliveryForecast',
        text: 'Previsão de Entrega'
      },
      {
        value: 'emissionDate',
        text: 'Data de Emissão'
      },
      {
        value: 'senderName',
        text: 'Enviado por'
      },
      { value: 'actions', text: 'Ações' }
    ],
    columnsDeliveries: [
      'type',
      'numberCte',
      'authorizationDate',
      'costFreight',
      'deliveryForecast',
      'emissionDate',
      'senderName',
      'actions'
    ],
    columnsNfeOptions: [
      {
        value: 'type',
        text: 'Tipo'
      },
      { value: 'number', text: 'Número NFE' },
      { value: 'price', text: 'Preço da NF' },
      { value: 'weight', text: 'Peso da NF' },
      { value: 'completionDate', text: 'Data de Conclusão' }
    ],
    columnsNfe: ['type', 'number', 'price', 'weight', 'completionDate'],
    selectedCheckbox: []
  }),

  computed: {
    ...mapState('TranshipmentStore', ['paginateTransfer']),
    page: {
      get() {
        return this.paginateTransfer.pageNumber;
      },
      set(value) {
        this.selectedCheckbox = [];
        this.setPageNumberTransfer(value);

        this.fetchStops();
      }
    },

    filteredDeliverers() {
      return this.deliverers.filter((item) => {
        return item.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1;
      });
    },

    hasAllDeliverersSelected() {
      const totalDeliverers = this.filteredDeliverers.length;
      const totalSelectedDeliverers = this.selectedDeliverers.length;
      return totalDeliverers !== 0 && totalDeliverers === totalSelectedDeliverers;
    },

    hasDeliverers() {
      return this.deliverers.length;
    },

    stopsTranshipmentId() {
      return TranshipmentTransferHandler.getSelectedTranshipmentId(this);
    },

    transhipmentToTransferId() {
      return TranshipmentTransferHandler.getSelectedTranshipmentToTransferId(this);
    },

    hasTranshipmentToTransferId() {
      return TranshipmentTransferHandler.getSelectedTranshipmentToTransferId(this) !== null;
    },

    shouldDisableButton() {
      const hasSelected = this.selectedCheckbox.length > 0;

      if (hasSelected && this.hasTranshipmentToTransferId) return false;
      else return true;
    }
  },

  watch: {
    stopsTranshipmentId: {
      handler() {
        this.setPageNumberTransfer(1);
        this.fetchStops();
        this.selectedCheckbox = [];
      }
    },
    nfeNumber: {
      handler(value) {
        if (value === '') {
          this.setFiltersNfeNumberId(null);
          this.fetchStops();
        }
      }
    }
  },

  created() {
    this.fetchStops();
  },

  methods: {
    ...mapActions('TranshipmentStore', [
      'fetchTranshipmentBetweenStops',
      'fetchTranshipmentBetweenDeliveriesPending',
      'fetchTranshipmentBetweenNfes'
    ]),
    ...mapMutations('TranshipmentStore', ['setPageNumberTransfer', 'setFiltersNfeNumberId']),

    async fetchStops() {
      this.loadingStops = true;
      try {
        const data = await this.fetchTranshipmentBetweenStops(this.stopsTranshipmentId);
        this.nodes = data.map((item, index) => {
          return {
            key: `${index}`,
            data: {
              ...item,
              recipientCpfOrCnpj: this.transformCpfOrCnpj(item.recipientCpfOrCnpj),
              transhipmentPrice: this.transformPrice(item.transhipmentPrice),
              type: 'Parada'
            },
            children: [],
            type: 'Stops',
            open: false,
            selected: false
          };
        });
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingStops = false;
      }
    },

    searchNfeNumber() {
      this.selectedCheckbox = [];
      this.setFiltersNfeNumberId(this.nfeNumber);
      this.fetchStops();
    },

    transferStops() {
      this.$emit('transferStops', this.selectedCheckbox);
    },

    async onExpand(selected) {
      this.loadingStops = true;
      if (selected.type === 'Stops') {
        const stopKey = Number(selected.key);
        this.nodes[stopKey].open = !this.nodes[stopKey].open;
        const { id: stopId } = selected.data;
        try {
          const data = await this.fetchTranshipmentBetweenDeliveriesPending(selected.data.id);

          const newDeliveries = data.map((item, index) => {
            return {
              key: `${selected.key}-${index}`,
              data: {
                ...item,
                authorizationDate: this.transformDate(item.authorizationDate),
                deliveryForecast: this.transformDate(item.deliveryForecast),
                emissionDate: this.transformDate(item.emissionDate),
                type: 'Entrega',
                stopId
              },
              children: [],
              type: 'Deliveries',
              open: false,
              selected: false
            };
          });
          if (this.nodes[stopKey].children.length === 0) {
            this.nodes[stopKey].children = newDeliveries;
          }

          if (selected.selected) {
            this.nodes[stopKey].children.map((item) => {
              item.selected = true;
              if (!this.selectedCheckbox.includes(item.data)) {
                this.selectedCheckbox.push(item.data);
              }
            });
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.loadingStops = false;
        }
      }
      if (selected.type === 'Deliveries') {
        const stopIndex = Number(selected.key.split('-')[0]);
        const deliverIndex = Number(selected.key.split('-')[1]);
        this.nodes[stopIndex].children[deliverIndex].open = !this.nodes[stopIndex].children[deliverIndex].open;

        try {
          const statusesIds = [1, 2, 12, 3, 4, 14];
          const id = selected.data.id;
          const data = await this.fetchTranshipmentBetweenNfes({ id, statusesIds });

          const newNfe = data.map((item, index) => {
            return {
              key: `${selected.key}-${index}`,
              data: {
                ...item,
                completionDate: this.transformDate(item.completionDate),
                type: 'Nota Fiscal'
              },
              type: 'Nfe'
            };
          });

          this.nodes[stopIndex].children[deliverIndex].children = newNfe;
        } catch (err) {
          console.error(err);
        } finally {
          this.loadingStops = false;
        }
      }
    },

    changeSelectedCheckbox(item, children, shipmentIndex, cargoIndex, stopIndex) {
      this.selectedCheckbox = changeCheckbox(
        this.selectedCheckbox,
        item,
        children,
        shipmentIndex,
        cargoIndex,
        stopIndex,
        this.nodes[stopIndex]
      );
    },

    clearFilters() {
      this.nfeNumber = null;
      this.setFiltersNfeNumberId(null);
    },

    search() {},

    transformCpfOrCnpj(str) {
      if (str.length === 11) {
        return maskCPF(str);
      }
      return maskCNPJ(str);
    },

    transformPrice(price) {
      return maskPrice(price);
    },

    transformDate(date) {
      return maskData(date);
    }
  }
};
</script>

<style></style>
